import { useContext, useEffect, useReducer, useRef, useState } from "react";
import { DisplayUserPicAndName, FormatTimePassedUtc, ItemID } from "../newComponents/GeneralClasses";
import { HbrAvatarProfile, HbrMoreVert, HbrSendIcon } from "../newComponents/Mycustomsvgicons";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { AuthContext } from "../AuthContext";
import { deleteDoc, doc, setDoc } from "firebase/firestore";
import db from "../firebase";
import CustomTextArea from "./CustomTextArea";
import { useNavigate } from "react-router-dom";

const ReplyReviewContent = ({userName: userNameOnReply, email, message, timestamp, userReplied, replyID, reviewID}) => {
    const [profile_pic, setProfilePic] = useState("");
    const [userNameToDisplay, setUserNameToDisplay] = useState("");
    const [state, dispatch]=useReducer(reducer,{showMenu: false, showDelete: false, showReplyBox: false, replyText: "", sendingTask: false});
    const {user_email} = useContext(AuthContext);
    const {userName} = useContext(AuthContext);
    const menuRef = useRef(null);
    const replyBoxRef = useRef(null);
    const navigate = useNavigate();

    useEffect(()=>{
        async function getUserInfo() {
            const userInfo = await DisplayUserPicAndName(email);
            if (userInfo) {
                const nameFromDB = userInfo.name && userInfo.name !== "" ? userInfo.name : userNameOnReply;
                setUserNameToDisplay(nameFromDB);
                setProfilePic(userInfo.profilePic);
            };
        }
        getUserInfo();
    },[email, userNameOnReply]);

    useEffect(()=>{
        if (state.showMenu || state.showReplyBox) {
            const menuOutsideTouchable=(e)=>{
                if (menuRef.current) {
                    if (!menuRef.current.contains(e.target)) {
                        dispatch({type: actionConsts.SHOW_MENU, payload: false});
                    }
                }
            }

            const dismissReplyBox=(e)=>{
                if (replyBoxRef.current) {
                    if (!replyBoxRef.current.contains(e.target)) {
                        dispatch({type: actionConsts.SHOW_REPLY_BOX, payload: false});
                        dispatch({type: actionConsts.REPLY_TEXT, payload: ""});
                    }
                }
            }

            document.addEventListener("mousedown", menuOutsideTouchable);
            document.addEventListener("mousedown", dismissReplyBox);
            return()=> {
                document.removeEventListener("mousedown", menuOutsideTouchable); 
                document.removeEventListener("mousedown", dismissReplyBox); 
            }   
        }
    },[state.showMenu, state.showReplyBox]);

    useEffect(()=>{
        if (email === user_email) {
            dispatch({type: actionConsts.SHOW_DELETE, payload: true});
        }else{
            dispatch({type: actionConsts.SHOW_DELETE, payload: false});
        }
    },[email, user_email]);

    const toggleMenuVisibility=()=>{
        dispatch({type: actionConsts.SHOW_MENU, payload: true});
    };

    const deleteReply=async()=>{
        if (email === user_email) {
            const docRef = doc(db,"reply reviews",replyID);
            await deleteDoc(docRef);
            dispatch({type: actionConsts.SHOW_MENU, payload: false});
        }
    };

    const handleShowReply=()=>{
        dispatch({type: actionConsts.SHOW_REPLY_BOX, payload: true});
        dispatch({type: actionConsts.SHOW_MENU, payload: false});
    };

    const sendReply=async()=>{
        dispatch({type: actionConsts.SENDING_TASK, payload: true});
        const reply_id = ItemID();
        const timestamp = new Date().getTime();
        await setDoc(doc(db,"reply reviews", reply_id),{
            name: userName,
            email: user_email,
            message: state.replyText,
            replyID: reply_id,
            reviewID,
            userReplied: userNameOnReply,
            timestamp
        });
        dispatch({type: actionConsts.SENDING_TASK, payload: false});
        dispatch({type: actionConsts.SHOW_REPLY_BOX, payload: false});
        dispatch({type: actionConsts.REPLY_TEXT, payload: ""});
    };





    return ( 
        <div className="replytoreviewcontent flex-column1">
           <div className="flex-spacebetween" style={{width:"100%"}}>
                <div className="reviewtopuserinfo flex-row2" style={{gap:"20px"}}>

                    {profile_pic && profile_pic !== "" ? (
                        <img src={profile_pic} alt="" style={{width:"2em", height:"2em", objectFit:"cover", borderRadius:"50%"}}/>
                    ):(
                    <div><HbrAvatarProfile width={"2em"} height={"2em"}/></div>
                    )}

                    <p style={{fontWeight:"bold"}}>{userNameToDisplay}</p>

                    <p>{FormatTimePassedUtc(timestamp)}</p>
                </div>

                <div style={{position:"relative"}}>
                     <HbrMoreVert width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>toggleMenuVisibility()}/>

                    {state.showMenu && 
                        <div className="reviewcontentmenuitems flex-column1" ref={menuRef}>
                            <button onClick={()=>handleShowReply()}>Reply</button>
                            <button onClick={()=>navigate("/contact")}>Report</button>
                            {state.showDelete && <button onClick={()=>deleteReply()}>Delete</button>}
                        </div>
                    }
               
                </div>
            </div>

            <p style={{color:"#0E78F9", fontWeight:"bold"}}>{`@${userReplied}`}</p>

            <pre>{message}</pre>
            {state.showReplyBox && 
                <div className="replyreviewtextboxholder flex-row2" ref={replyBoxRef}>
                    <CustomTextArea
                    value={state.replyText} 
                    onChange={e => dispatch({type: actionConsts.REPLY_TEXT, payload: e.target.value})}
                    textareaLineHeight={48} 
                    hint={`Reply @${userNameOnReply}`} 
                    maxRows={6}/>
                    <HbrSendIcon width={"2em"} height={"2em"} fillColour={"#1C1F2E"} handleClick={()=>sendReply()}/>
                </div>
            }

        </div>
     );
}
export default ReplyReviewContent;